import { createFileRoute } from '@tanstack/react-router'
import { RegisterInstitutionPage } from '@/pages/authentication/ui/RegisterInstitutionPage'

export const Route = createFileRoute('/register-edu')({
  component: RegisterInstitutionPage,
})
